// extracted by mini-css-extract-plugin
export default {"container":"TodoList_container__DBs2s","container__inner":"TodoList_container__inner__UBHs1","list__wrap":"TodoList_list__wrap__gMsMs","list":"TodoList_list__dqQoz"};